import { render } from "./Courses.vue?vue&type=template&id=4e9095de&scoped=true"
import script from "./Courses.vue?vue&type=script&lang=js"
export * from "./Courses.vue?vue&type=script&lang=js"

import "./Courses.vue?vue&type=style&index=0&id=4e9095de&scoped=true&lang=css"

import exportComponent from "/Users/am/Projects/jeet_edit/quiztest_edit/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e9095de"]])

export default __exports__